import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaBrainHistoryMenuRegistry = {
    personalize_nebulaBrainHistory: {
        label: "Nebula Brain History",
        link: PAGE_URL.NEBULA_BRAIN_HISTORY_PAGE,
        key: PAGE_URL.NEBULA_BRAIN_HISTORY_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaBrainHistoryMenuRegistry;
